export class Utility {
  static isUserTokenExpired(exp: number): boolean {
    return exp ? new Date(exp * 1000) < new Date() : true;
  }

  static convertToPascalCase = (str: string) => {
    if (str) {
      if (str.length === 1) {
        return str.toUpperCase();
      } else if (str.length > 1) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
    }
    return "";
  };

  /**
   * Convert seconds.
   * @returns Converted seconds to hours,minutes,seconds.
   */
  static getTimeRemaining(totalSecs: number) {
    var hours = Math.floor(totalSecs / (60 * 60));

    var divisor_for_minutes = totalSecs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    return {
      totalSecs,
      hours,
      minutes,
      seconds,
    };
  }
}
